module.exports = __webpack_public_path__ + "img/mainImg.3b4ac66f.png";